/*eslint-disable*/
export default valentines_navbar => {
  let $valentines_navbar = $(valentines_navbar)
  if (document.querySelector('body').classList.contains('template-article')) {
    let article_href = window.location.pathname.split('magazine/')[1]
    $valentines_navbar.find(`.js-nav-category[data-magazine-href=${article_href}]`).addClass('selected')
    $valentines_navbar.find('.js-nav-category').each((idxr, chapter) => $(chapter).click((e) => window.location.href = ($(e.target).data('magazine-href'))))
  }
}


// WEBPACK FOOTER //
// ./src/scripts/components/valentines-gift-guide-nav-selection.js